import TagButton from "../../../../../components/features/TagButton";
import { Tag } from "../DownloadForm";

type Props = {
  title: string;
  tags: Tag[];
  selectedTagIds: string[];
  onTagToggle: (tagId: string) => void;
};

export const TagGroup = ({
  title,
  tags,
  selectedTagIds,
  onTagToggle,
}: Props) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="text-[1.4rem] font-bold mb-3 text-[#7B8195]">{title}</div>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => {
          const isSelected = selectedTagIds.includes(tag.id);
          return (
            <TagButton
              key={tag.id}
              label={tag.name}
              variant="solid"
              colorType={isSelected ? "primary" : "gray-lighten-2"}
              hoverVariant="solid"
              hoverColorType="primary"
              onClick={() => onTagToggle(tag.id)}
            />
          );
        })}
      </div>
    </div>
  );
};
